import React from 'react';
import Card from '../../../components/Classroom/Card';

const StreamTab = ({ classroomDetails }) => {
  const { name, joinCode, students } = classroomDetails;

  const copyToClipboard = () => {
    navigator.clipboard.writeText(joinCode);
    alert('Class code copied to clipboard!');
  };

  return (
    <div className="stream-tab">
      <Card title="Classroom Name">
        <div className="classroom-name">{name}</div>
      </Card>
      <Card title="Class Code">
        <div className="class-code" onClick={copyToClipboard} title="Copy to clipboard">
          {joinCode} <i className="bi bi-clipboard"></i>
        </div>
      </Card>
      <Card title="Total students">
        <div className="total-students">{students.length}</div>
      </Card>
    </div>
  );
};

export default StreamTab;